class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomImages: '[data-pswp-image]',
      btnXr: '[data-shopify-xr]'
    };
    const sliderEl = this.querySelector(this.selectors.slider);
    this.selectedMediaIndex =
      Number(
        sliderEl?.querySelector('[data-selected]')?.dataset.index
      ) || 0;
    const sectionRoot =
      this.closest(`[id^="MainProduct-"]`) || this.closest('.js-product') || document;
    const productSelectorEl =
      sectionRoot?.querySelector?.('product-selector') || null;
    const isCustomProduct =
      productSelectorEl?.dataset?.mobileVariantStepper === 'true' ||
      productSelectorEl?.dataset?.templateSuffix === 'custom-product' ||
      (productSelectorEl?.dataset?.template || '').includes('custom-product');
    this._isCustomProduct = isCustomProduct;
    if (isCustomProduct) {
      this.selectedMediaIndex = 0;
    }
    this._dbgSend = () => {};

    let swiperOptions = {};
    try {
      swiperOptions = JSON.parse(
        sliderEl?.getAttribute('data-swiper-options') || '{}'
      );
    } catch (e) {
      swiperOptions = {};
    }

    if (Shopify.designMode) {
      this.addEventListener('shopify:section:load', event => {
        this.init();
      });
    }
    const withThumbs = this.dataset.withThumbs;
    const isWellnessSlider =
      this.getAttribute('data-wellness-slider') === 'true';
    const isWellnessTemplate =
      this.getAttribute('data-wellness-template') === 'true';
    const isDsFashionTemplate =
      this.getAttribute('data-ds-fashion-template') === 'true';

    // In Shopify design mode, section markup can be in a transient state.
    // Avoid crashing constructor when slider DOM is not yet available.
    if (!sliderEl) {
      this.settings = {
        sliderElement: null,
        sliderInstance: null,
        options: {}
      };
      return;
    }
    let slidesPerViewDesktop =
      typeof swiperOptions.slidesPerViewDesktop === 'number'
        ? swiperOptions.slidesPerViewDesktop
        : 2;
    const forceSingleWellnessSlides =
      isWellnessTemplate && !isWellnessSlider;
    if (forceSingleWellnessSlides) {
      slidesPerViewDesktop = 1;
    }

    const paginationEl = sliderEl.querySelector('.swiper-pagination');
    const navRoot = sliderEl.parentElement || this;

    this.queuedMediaIndex = null;
    this.queuedMediaRaf = null;

    if (withThumbs === 'true') {
      let setWrapperStyles = function (swiper) {
        let wrapperCenterClass = 'swiper-wrapper__center';
        let buttonDisabledClass = swiper.params.buttonDisabledClass;
        let wrapperEl = swiper.wrapper[0];

        if (
          swiper.prevButton[0].classList.contains(
            buttonDisabledClass
          ) &&
          swiper.nextButton[0].classList.contains(buttonDisabledClass)
        ) {
          wrapperEl.classList.add(wrapperCenterClass);
        } else {
          wrapperEl.classList.remove(wrapperCenterClass);
        }
      };

      this._useThumbnailCarousel =
        !!this.querySelector('.thumbnail-carousel');
    }

    // Count only the main gallery slides. Single-slide behavior is scoped
    // to DS Fashion to avoid changing other product templates.
    const totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;
    const isSingleSlide = totalSlides <= 1;
    sliderEl?.classList?.toggle('one-slide', isSingleSlide);
    if (isSingleSlide) {
      slidesPerViewDesktop = 1;
    }

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        initialSlide: this.selectedMediaIndex,
        slidesPerView: 1,
        loop: false,
        centeredSlides: swiperOptions.centerInsufficientSlides && isSingleSlide,
        centerInsufficientSlides: swiperOptions.centerInsufficientSlides || false,
        navigation: {
          prevEl: navRoot.querySelector('.swiper-button--prev'),
          nextEl: navRoot.querySelector('.swiper-button--next')
        },

        pagination:
          isSingleSlide || !paginationEl
            ? false
            : {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
                dynamicBullets: false
              },

        slidesPerGroup: 1,
        spaceBetween: 0,
        rewind: !isSingleSlide,
        watchOverflow: !isSingleSlide,
        allowTouchMove: !isSingleSlide,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        autoHeight: this.dataset.autoHeight === 'true',

        on: {
          afterInit: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              const firstSlide = swiper.slides[0];

              const firstSlideVideo =
                firstSlide.querySelector('video');

              if (firstSlideVideo) {
                this.playPromise(firstSlideVideo);
              }

              // if firstSlide has youtube, play it
              const firstSlideYoutube =
                firstSlide.querySelector('.js-youtube');
              if (firstSlideYoutube) {
                this.playYoutubeVideo(firstSlideYoutube);
              }

              // if firstSlide has vimeo, play it
              const firstSlideVimeo =
                firstSlide.querySelector('.js-vimeo');
              if (firstSlideVimeo) {
                this.playVimeoVideo(firstSlideVimeo);
              }
            }
          },

          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          slideChange: swiper => {
            if (window.innerWidth >= 990) {
              const swiperContainer = swiper.el;
              if (swiperContainer) {
                swiperContainer.style.marginInlineStart = '0';
              }
            }
          },
          transitionEnd: swiper => {
            const isSwiperGenerated =
              swiper.slides.length > 1 ? true : false;

            if (isSwiperGenerated) {
              let slideIndex = swiper.activeIndex;

              const swiperCardWidth = swiper.slides[0].offsetWidth;

              slideIndex = Math.abs(
                Math.floor(swiper.translate / [swiperCardWidth])
              );

              const activeSlide = Array.from(swiper.slides).find(
                sliderSlide =>
                  sliderSlide.classList.contains(
                    'swiper-slide-active'
                  )
              );

              // play or pause videos in active and next slides
              const activeSlideVideo =
                activeSlide.querySelector('video');
              const nextSlideVideo =
                activeSlide.nextElementSibling?.querySelector(
                  'video'
                );

              const playVideo = video => {
                if (video && video.paused) {
                  this.playPromise(video);
                } else if (video) {
                  video.pause();
                }
              };

              playVideo(activeSlideVideo);
              playVideo(nextSlideVideo);

              const activeSlideYoutube =
                activeSlide.querySelector('.js-youtube');
              if (activeSlideYoutube) {
                this.playYoutubeVideo(activeSlideYoutube);
              }

              const activeSlideVimeo =
                activeSlide.querySelector('.js-vimeo');
              if (activeSlideVimeo) {
                this.playVimeoVideo(activeSlideVimeo);
              }
            }
          }
        }
      }
    };

    if (withThumbs === 'true') {
      if (!this._useThumbnailCarousel) {
        const thumbsSlidesPerViewMobile =
          typeof swiperOptions.thumbsSlidesPerViewMobile === 'number'
            ? swiperOptions.thumbsSlidesPerViewMobile
            : 6;
        const thumbsSpaceBetweenMobile =
          typeof swiperOptions.thumbsSpaceBetweenMobile === 'number'
            ? swiperOptions.thumbsSpaceBetweenMobile
            : 2;
        const thumbsSlidesPerViewDesktop =
          typeof swiperOptions.thumbsSlidesPerViewDesktop === 'number'
            ? swiperOptions.thumbsSlidesPerViewDesktop
            : 5;
        const thumbsSpaceBetweenDesktop =
          typeof swiperOptions.thumbsSpaceBetweenDesktop === 'number'
            ? swiperOptions.thumbsSpaceBetweenDesktop
            : 5;

        const thumbSettings = {
          swiper: {
            el: '.swiper-thumbs',

            initialSlide: this.selectedMediaIndex,

            centeredSlides: true,
            centeredSlidesBounds: true,
            freeMode: {
              enabled: true,
              sticky: true
            },
            direction: 'horizontal',

            slidesPerView: thumbsSlidesPerViewMobile,
            spaceBetween: thumbsSpaceBetweenMobile,

            threshold: 5,

            watchOverflow: !isSingleSlide,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,

            breakpoints: {
              750: {
                direction: swiperOptions.thumbsDirectionDesktop,
                spaceBetween: thumbsSpaceBetweenDesktop,
                slidesPerView: thumbsSlidesPerViewDesktop
              }
            },

            on: {
              touchEnd: function (s, e) {
                let range = 5;
                let diff = (s.touches.diff = s.isHorizontal()
                  ? s.touches.currentX - s.touches.startX
                  : s.touches.currentY - s.touches.startY);
                if (diff < range || diff > -range) s.allowClick = true;
              },
              afterInit: () => {
                this.querySelector('.swiper-thumbs').removeAttribute('style');
              }
            }
          }
        };

        this.settings.options.thumbs = thumbSettings;

        this.settings.options.on.init = swiper => {
          setTimeout(() => {
            swiper.thumbs.swiper.el.classList.add(
              'swiper-thumbs--visible'
            );
          }, 10);
        };

        this.settings.options.on.slideChangeTransitionStart =
          swiper => {
            const thumbsSwiper = swiper.thumbs.swiper;
            const activeIndex = swiper.activeIndex;
            const thumbsActiveIndex = thumbsSwiper.activeIndex;
            if (activeIndex !== thumbsActiveIndex) {
              thumbsSwiper.slideTo(activeIndex);
            }
          };
      }

      this.settings.options.breakpoints = {
        750: {
            slidesPerView: slidesPerViewDesktop,
            slidesPerGroup: 1,
            centeredSlides: swiperOptions.centerInsufficientSlides && isSingleSlide,
          },
        1350: {
            slidesPerView: slidesPerViewDesktop,
            slidesPerGroup: 1,
            centeredSlides: swiperOptions.centerInsufficientSlides && isSingleSlide,
          },
        1920: {
            slidesPerView: slidesPerViewDesktop,
            slidesPerGroup: 1,
            centeredSlides: swiperOptions.centerInsufficientSlides && isSingleSlide,
          }
      };
    } else {
      this.settings.options.slidesPerView = 1;
      this.settings.options.centeredSlides = false;
      this.settings.options.breakpoints = {
        750: {
          slidesPerView: slidesPerViewDesktop,
          slidesPerGroup: 1
        },
        1350: {
          slidesPerView: slidesPerViewDesktop,
          slidesPerGroup: 1
        },
        1920: {
          slidesPerView: slidesPerViewDesktop,
          slidesPerGroup: 1
        }
      };
    }
  }

  playPromise(video) {
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Automatic playback started!
          // Show playing UI.
          // video.play();
        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          video.pause();
        });
    }
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage(
      '{"event":"command","func":"' + 'playVideo' + '","args":""}',
      '*'
    );
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
    if (!this.classList.contains('is-media-updating')) {
      requestAnimationFrame(() => {
        this.classList.add('is-media-ready');
      });
    }
  }

  disconnectedCallback() {
    if (this._layoutModeResizeBound) {
      window.removeEventListener('resize', this._layoutModeResizeBound);
      this._layoutModeResizeBound = null;
    }
    this.teardownSwiperLayoutWatchers();
    if (this._thumbnailInstance) {
      this._thumbnailInstance.destroy();
      this._thumbnailInstance = null;
    }
  }

  teardownSwiperLayoutWatchers() {
    if (this._swiperLayoutObserver) {
      try {
        this._swiperLayoutObserver.disconnect();
      } catch (e) {}
      this._swiperLayoutObserver = null;
    }
    if (this._swiperLayoutResizeBound) {
      window.removeEventListener('resize', this._swiperLayoutResizeBound);
      this._swiperLayoutResizeBound = null;
    }
  }

  refreshSwiperLayout() {
    const inst = this.settings?.sliderInstance;
    const el = this.settings?.sliderElement;
    if (!inst || inst.destroyed || !el) return;
    try {
      inst.update();
    } catch (e) {}
    try {
      if (inst.navigation && typeof inst.navigation.update === 'function') {
        inst.navigation.update();
      }
    } catch (e) {}
    try {
      if (this._thumbnailInstance) {
        this._thumbnailInstance.refresh();
      } else {
        const thumbs = inst.thumbs?.swiper;
        if (thumbs && !thumbs.destroyed) {
          thumbs.update();
          if (
            thumbs.navigation &&
            typeof thumbs.navigation.update === 'function'
          ) {
            thumbs.navigation.update();
          }
        }
      }
    } catch (e) {}
    this.alignNavigationToGalleryCenter();
    this.updateGalleryNavigationVisibility();
  }

  alignNavigationToGalleryCenter() {
    const sliderEl = this.settings?.sliderElement;
    if (!sliderEl) return;
    const nav = sliderEl.parentElement?.querySelector('.swiper-buttons');
    if (!nav) return;

    const sliderRect = sliderEl.parentElement?.getBoundingClientRect();
    const galleryRect = sliderEl.getBoundingClientRect();
    if (!sliderRect || !galleryRect || !galleryRect.height) return;

    const topWithinSlider =
      galleryRect.top - sliderRect.top + galleryRect.height / 2;
    nav.style.insetBlockStart = `${topWithinSlider}px`;
    nav.style.transform = 'translateY(-50%)';
  }

  getMainGallerySlideCount() {
    const inst = this.settings?.sliderInstance;
    if (inst && !inst.destroyed) {
      try {
        return inst.slides.filter(
          slide => !slide.classList.contains('swiper-slide-duplicate')
        ).length;
      } catch (e) {
        /* fall through */
      }
    }
    const slider =
      this.settings?.sliderElement ||
      this.querySelector(this.selectors.slider);
    if (!slider) return 0;
    return slider.querySelectorAll(
      '.swiper-slide:not(.swiper-slide-duplicate)'
    ).length;
  }

  updateGalleryNavigationVisibility() {
    const isDsFashionTemplate =
      this.getAttribute('data-ds-fashion-template') === 'true';
    if (!isDsFashionTemplate) {
      this.querySelector('.swiper-buttons')?.classList.remove('hidden');
      return;
    }
    const n = this.getMainGallerySlideCount();
    this.querySelector('.swiper-buttons')?.classList.toggle('hidden', n <= 1);
  }

  init() {
    const [
      zoomContainerWidth,
      zoomContainerHeight,
      closeIcon,
      prevIcon,
      nextIcon
    ] = [
      this.offsetWidth,
      this.offsetHeight,
      this.querySelector('[data-close-icon]'),
      this.querySelector('[data-prev-icon]'),
      this.querySelector('[data-next-icon]')
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

  if (!this._photoSwipeInitialized) {
      const photoSwipeLightboxInstance = new PhotoSwipeLightbox({
        gallery: `#${this.settings.sliderElement.id}`,
        children: 'a',
        mainClass: 'pswp--product-media-gallery',

        loop: false,
        showHideAnimationType: 'zoom',

        initialZoomLevel: zoomLevelObject => {
          if (isPhone()) {
            return zoomLevelObject.vFill;
          } else {
            return zoomLevelObject.fit;
          }
        },
        secondaryZoomLevel: zoomLevelObject => {
          if (isPhone()) {
            return zoomLevelObject.fit;
          } else {
            return 1;
          }
        },
        pswpModule: PhotoSwipe
      });
      photoSwipeLightboxInstance.addFilter(
        'uiElement',
        (element, data) => {
          if (data.name === 'close') {
            element.innerHTML = closeIcon.innerHTML;
          } else if (data.name === 'arrowPrev') {
            element.innerHTML = prevIcon.innerHTML;
          } else if (data.name === 'arrowNext') {
            element.innerHTML = nextIcon.innerHTML;
          }
          return element;
        }
      );

      photoSwipeLightboxInstance.addFilter(
        'itemData',
        (itemData, index) => {
          if (itemData.type === 'html' && itemData.element) {
            return {
              html: itemData.element.dataset.pswpHtml
            };
          }
          return itemData;
        }
      );

      photoSwipeLightboxInstance.init();

      photoSwipeLightboxInstance.on('beforeOpen', () => {
        const videos = this.querySelectorAll('video');
        Array.from(videos).forEach(video => {
          video
            .play()
            .then(() => {})
            .catch(error => {
              video.pause();
            });
        });
      });

      this._photoSwipeInitialized = true;
      this._photoSwipeLightbox = photoSwipeLightboxInstance;
    }

    this.addEventListener('dragstart', event => {
      event.preventDefault();
    });

    if (!this.settings.sliderElement) return;

    this.teardownSwiperLayoutWatchers();

    if (this.settings.sliderInstance && !this.settings.sliderInstance.destroyed) {
      try {
        this.settings.sliderInstance.destroy(true, true);
      } catch (e) {}
    }

    const wantsDesktopGrid =
      this.dataset.desktopGrid === 'true' && window.innerWidth >= 750;
    this.classList.toggle('is-desktop-grid', wantsDesktopGrid);
    this._layoutMode = wantsDesktopGrid ? 'grid' : 'swiper';

    if (!this._layoutModeResizeBound) {
      this._layoutModeResizeBound = () => {
        const wants =
          this.dataset.desktopGrid === 'true' && window.innerWidth >= 750;
        const nextMode = wants ? 'grid' : 'swiper';
        if (nextMode !== this._layoutMode) {
          this.init();
        }
      };
      window.addEventListener('resize', this._layoutModeResizeBound);
    }

    if (wantsDesktopGrid) {
      this.settings.sliderElement.classList.add('swiper-initialized');
      this._setDesktopGridSlidesToCurrentSelection();
      this.settings.sliderInstance = null;
      if (this._thumbnailInstance) {
        this._thumbnailInstance.destroy();
        this._thumbnailInstance = null;
      }
      return;
    }

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );

    if (this._useThumbnailCarousel) {
      this._initThumbnailCarousel();
    }

    const sliderEl = this.settings.sliderElement;
    this._swiperLayoutObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => this.refreshSwiperLayout());
    });
    try {
      this._swiperLayoutObserver.observe(sliderEl);
    } catch (e) {}

    this._swiperLayoutResizeBound = () => {
      requestAnimationFrame(() => this.refreshSwiperLayout());
    };
    window.addEventListener('resize', this._swiperLayoutResizeBound);

    requestAnimationFrame(() => {
      this.refreshSwiperLayout();
      requestAnimationFrame(() => {
        this.refreshSwiperLayout();
        if (this.classList.contains('is-media-updating')) {
          requestAnimationFrame(() => {
            this.classList.remove('is-media-updating');
            this.classList.add('is-media-ready');
          });
        }
      });
    });
  }


  _setDesktopGridSlidesToCurrentSelection() {
    const sliderEl = this.settings?.sliderElement;
    const wrapper = sliderEl?.querySelector?.('.swiper-wrapper');
    if (!wrapper) return;

    if (!this.originalSlides) {
      this.originalSlides = Array.from(wrapper.children);
    }

    const sourceSlides = Array.isArray(this.originalSlides) && this.originalSlides.length
      ? this.originalSlides
      : Array.from(wrapper.children);

    const selectedSlide =
      sourceSlides.find(slide => slide?.hasAttribute?.('data-selected')) ||
      sourceSlides[0];
    if (!selectedSlide) return;

    const normalize = (value) => (value ?? '').toString().trim().toLowerCase();
    const targetStyle = normalize(selectedSlide.getAttribute('data-style'));
    const targetColor = normalize(selectedSlide.getAttribute('data-color'));
    const targetVariantGroup = normalize(selectedSlide.getAttribute('data-variant-group'));

    const hasAnyStyleMatch = targetStyle
      ? sourceSlides.some(s => normalize(s.getAttribute('data-style')) === targetStyle)
      : false;
    const hasAnyColorMatch = targetColor
      ? sourceSlides.some(s => normalize(s.getAttribute('data-color')) === targetColor)
      : false;
    const hasAnyVariantGroupMatch = targetVariantGroup
      ? sourceSlides.some(s => normalize(s.getAttribute('data-variant-group')) === targetVariantGroup)
      : false;

    const nextSlides = sourceSlides.filter(slide => {
      if (!slide) return false;
      if (slide.getAttribute('data-custom-strap') === 'true') return true;
      if (hasAnyVariantGroupMatch && normalize(slide.getAttribute('data-variant-group')) !== targetVariantGroup) {
        return false;
      }
      if (hasAnyStyleMatch && normalize(slide.getAttribute('data-style')) !== targetStyle) {
        return false;
      }
      if (hasAnyColorMatch && normalize(slide.getAttribute('data-color')) !== targetColor) {
        return false;
      }
      return true;
    });

    const finalSlides = nextSlides.length ? nextSlides : sourceSlides;
    wrapper.innerHTML = '';
    finalSlides.forEach(slide => wrapper.appendChild(slide));
  }

  _initThumbnailCarousel() {
    const carouselEl = this.querySelector('.thumbnail-carousel');
    if (!carouselEl) return;

    if (typeof ThumbnailCarousel === 'undefined') {
      return;
    }

    if (this._thumbnailInstance) {
      this._thumbnailInstance.destroy();
    }


    const slidesToShowRaw = Number.parseInt(carouselEl.dataset.slidesToShow, 10);
    const slidesToShow =
      Number.isFinite(slidesToShowRaw) && slidesToShowRaw > 0
        ? slidesToShowRaw
        : 5;
    carouselEl.style.setProperty('--thumbs-cols', slidesToShow);

    this._thumbnailInstance = new ThumbnailCarousel(carouselEl, {
      slidesToShow: 5,
      onChange: (index, item) => {
        const swiper = this.settings.sliderInstance;
        if (swiper && !swiper.destroyed) {
          const loopEnabled = !!swiper.params?.loop;
          carouselEl.dataset.loop = loopEnabled ? 'true' : 'false';
          // #region debug-point C:thumb-to-swiper
          window.__traeDbgPdpBlipClicks?.('C', 'thumb:onChange', {
            index,
            itemMediaId: item?.dataset?.mediaId || null,
            loopEnabled,
            swiper: {
              activeIndex: swiper.activeIndex,
              realIndex: swiper.realIndex,
              slidesPerView: swiper.params?.slidesPerView || null
            }
          });
          // #endregion
          if (loopEnabled && typeof swiper.slideToLoop === 'function') {
            swiper.slideToLoop(index);
          } else {
            swiper.slideTo(index);
          }
        }
      }
    });

    const swiper = this.settings.sliderInstance;
    if (swiper) {
      const syncThumbsFromSwiper = () => {
        if (!this._thumbnailInstance || !swiper || swiper.destroyed) return;
        carouselEl.dataset.loop = !!swiper.params?.loop ? 'true' : 'false';
        const activeIndex =
          swiper.realIndex !== undefined ? swiper.realIndex : swiper.activeIndex;
        // #region debug-point B:swiper-to-thumb
        try {
          const activeSlide = swiper.slides?.find?.(s =>
            s?.classList?.contains?.('swiper-slide-active')
          );
          const nextSlide = swiper.slides?.find?.(s =>
            s?.classList?.contains?.('swiper-slide-next')
          );
          const visibleSlides = (swiper.slides || []).filter(s =>
            s?.classList?.contains?.('swiper-slide-visible')
          );
          window.__traeDbgPdpBlipClicks?.('B', 'swiper:slideChange', {
            loopEnabled: !!swiper.params?.loop,
            activeIndex: swiper.activeIndex,
            realIndex: swiper.realIndex,
            derivedThumbIndex: activeIndex,
            slidesPerView: swiper.params?.slidesPerView || null,
            activeSlide: activeSlide
              ? {
                  mediaId: activeSlide.dataset?.mediaId || null,
                  swiperSlideIndex: activeSlide.dataset?.swiperSlideIndex || null
                }
              : null,
            nextSlide: nextSlide
              ? {
                  mediaId: nextSlide.dataset?.mediaId || null,
                  swiperSlideIndex: nextSlide.dataset?.swiperSlideIndex || null
                }
              : null,
            visibleMediaIds: visibleSlides
              .map(s => s.dataset?.mediaId || null)
              .slice(0, 6),
            thumbActiveIndex: this._thumbnailInstance.getActiveIndex()
          });
        } catch (e) {}
        // #endregion
        const visibleDomSlides = this.settings?.sliderElement
          ? Array.from(
              this.settings.sliderElement.querySelectorAll(
                '.swiper-slide-visible[data-media-id]'
              )
            )
          : [];
        const visibleIndices = visibleDomSlides
          .map(s => Number(s.dataset?.swiperSlideIndex))
          .filter(n => Number.isFinite(n));
        const visibleMediaIds = visibleDomSlides
          .map(s => (s?.dataset?.mediaId || '').toString())
          .filter(Boolean);
        if (
          typeof this._thumbnailInstance.setActiveMediaIds === 'function' &&
          visibleMediaIds.length
        ) {
          this._thumbnailInstance.setActiveMediaIds(visibleMediaIds);
        } else if (
          typeof this._thumbnailInstance.setActiveIndices === 'function' &&
          visibleIndices.length
        ) {
          this._thumbnailInstance.setActiveIndices(visibleIndices);
        } else if (activeIndex !== this._thumbnailInstance.getActiveIndex()) {
          this._thumbnailInstance.syncToIndex(activeIndex);
        }
      };

      swiper.on('afterInit', () => {
        requestAnimationFrame(() => syncThumbsFromSwiper());
      });

      swiper.on('slideChangeTransitionEnd', () => {
        syncThumbsFromSwiper();
      });
    }
  }

  cancelQueuedActiveMedia() {
    if (this.queuedMediaRaf) {
      cancelAnimationFrame(this.queuedMediaRaf);
    }
    this.queuedMediaRaf = null;
    this.queuedMediaIndex = null;
    this.queuedMediaLoopIndex = null;
  }

  setActiveMedia(id) {
    const swiper = this.settings.sliderInstance;
    if (!swiper || swiper.destroyed) return;

    const slides = Array.from(swiper.slides);
    const realSlides = slides.filter(
      slide => !slide.classList.contains('swiper-slide-duplicate')
    );

    let targetSlide = realSlides.find(
      slide => Number(slide.dataset.mediaId) === id
    );
    if (!targetSlide) {
      targetSlide = slides.find(slide => Number(slide.dataset.mediaId) === id);
    }

    let targetIndex = targetSlide ? realSlides.indexOf(targetSlide) : -1;
    if (targetIndex === -1) {
      if (realSlides.length) {
        targetIndex = 0;
      } else {
        return;
      }
    }

    const loopIndexAttr = targetSlide
      ? Number(targetSlide.getAttribute('data-swiper-slide-index'))
      : NaN;
    const loopIndex = Number.isNaN(loopIndexAttr) ? targetIndex : loopIndexAttr;

    this.queuedMediaIndex = targetIndex;
    this.queuedMediaLoopIndex = loopIndex;
    if (this.queuedMediaRaf) cancelAnimationFrame(this.queuedMediaRaf);

    const startedAt = performance.now();
    const apply = () => {
      if (!this.settings.sliderInstance || this.settings.sliderInstance.destroyed) {
        this.queuedMediaRaf = null;
        return;
      }

      if (this.queuedMediaIndex === null || this.queuedMediaLoopIndex === null) {
        this.queuedMediaRaf = null;
        return;
      }

      const loopEnabled = !!this.settings.sliderInstance.params?.loop;
      const isAlreadyActive = loopEnabled
        ? this.settings.sliderInstance.realIndex === this.queuedMediaLoopIndex
        : this.settings.sliderInstance.activeIndex === this.queuedMediaIndex;

      if (!this.settings.sliderInstance.animating && isAlreadyActive) {
        this.queuedMediaIndex = null;
        this.queuedMediaRaf = null;
        return;
      }

      const doSlideTo = index => {
        if (
          loopEnabled &&
          typeof this.settings.sliderInstance.slideToLoop === 'function'
        ) {
          this.settings.sliderInstance.slideToLoop(index, 0, false);
        } else {
          this.settings.sliderInstance.slideTo(index, 0, false);
        }
      };

      if (performance.now() - startedAt > 1500) {
        doSlideTo(loopEnabled ? this.queuedMediaLoopIndex : this.queuedMediaIndex);
        this.queuedMediaIndex = null;
        this.queuedMediaLoopIndex = null;
        this.queuedMediaRaf = null;
        return;
      }

      if (this.settings.sliderInstance.animating) {
        this.queuedMediaRaf = requestAnimationFrame(apply);
        return;
      }

      doSlideTo(loopEnabled ? this.queuedMediaLoopIndex : this.queuedMediaIndex);
      this.queuedMediaIndex = null;
      this.queuedMediaLoopIndex = null;
      this.queuedMediaRaf = null;
    };

    this.queuedMediaRaf = requestAnimationFrame(apply);
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');
    const isModel = activeSlide.dataset.mediaType === 'model';
    if (!isModel) return;
    const btnXr = this.querySelector(this.selectors.btnXr);
    btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);
